import styled from 'styled-components';
import {
  blue, white, red, teko, silver, tekoSemibold, quoteBlue,
} from '../../../utils/theme';

import { mobile, tablet } from '../../../utils/breakpoints';

const TabStyle = `
  cursor: pointer;
  text-align: center;
  flex-basis: 12.5%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-left: 1px solid ${silver};
  border-right: 1px solid ${silver};
  position: relative;
  transition: all .25s ease;

  &:first-of-type {
    border-left: none;
  }

  &:last-of-type {
    border-right: none;
  }

  .abbreviation {
    color: ${red};
    font-size: 4vw;
    ${tekoSemibold};
    margin-bottom: 10px;
    margin-top: 17%;
    -ms-transform: skewX(-10deg); /* IE 9 */
    -webkit-transform: skewX(-10deg); /* Safari */
    transform: skewX(-10deg); /* Standard syntax */
    @media(max-width: ${mobile.max}px) {
      font-size: 30px;
    }
    @media(min-width: 2000px) {
      font-size: 60px;
    }
  }

  &.expanded {
    &.minimized {
      justify-content: center;
    }
    .abbreviation {
      margin-top: 0;
    }
    ${({ background }) => {
    if (background) {
      return `
        background: url('${background}');
        background-size: cover;
        &.active {
          background: ${quoteBlue};
          -moz-box-shadow:    inset 0 0 30px rgba(2, 33, 79, 0.65);
          -webkit-box-shadow: inset 0 0 30px rgba(2, 33, 79, 0.65);
          box-shadow:         inset 0 0 30px rgba(2, 33, 79, 0.65);
      
          p, h3 {
            color: ${white};
          }
        }
      `;
    }
    return '/* No background to apply */';
  }};
  }

  &.dropdown-item {
    margin: 5px;
    height: 154px;
    box-shadow: 1.312px 1.509px 3.76px 0.24px rgba(0, 57, 156, 0.26);
    flex-basis: 135px;
    width: 135px;
    height: 154px;
    flex-grow: 0;
    flex-shrink: 0;

    &.active {
      display: none;
    }

    ${({ background }) => {
    if (background) {
      return `
        background: url('${background}');
        background-size: cover;
      `;
    }
    return '/* No background to apply */';
  }};
  }

  .cls-1 {
    fill: #fff;
    stroke-linejoin: round;
    stroke-width: 2px;
    fill-rule: evenodd;
    webkit-transition: 0.5s all 0s cubic-bezier(0.23, 1, 0.32, 1), 0.05s color, 0s background;
    transition: 0.5s all 0s cubic-bezier(0.23, 1, 0.32, 1), 0.05s color, 0s background;
  }

  svg {
    max-width: 80%;
    height: 60px;
    margin-bottom: 10px;
    margin-top: 34%;
    height: 3vw;

    @media(max-width: ${mobile.max}px) {
      height: 30px;
    }
  }

  &.ticket-selector {
    padding: 0 10px;
    svg {
      height: 2.5vw;
      margin-top: 12%;
    }

    @media(max-width: ${tablet.max}px) {
      svg {
        margin-top: 40%;
      }
    }
  }

  ${({ abbr }) => `
    #${abbr} {
      stroke: url(#linear-gradient-${abbr});
    }
  `} h3 {
    font-size: 16px;
    ${teko} font-weight: bold;
    color: ${blue};
    line-height: 1.2;
    letter-spacing: .10625rem;
    text-align: center;
    webkit-transition: 0.5s all 0s cubic-bezier(0.23, 1, 0.32, 1), 0.05s color, 0s background;
    transition: 0.5s all 0s cubic-bezier(0.23, 1, 0.32, 1), 0.05s color, 0s background;
  }

  &.minimized {
    h3 {
      line-height: 14px;
    }
  }

  &:hover {
    -moz-box-shadow:    inset 0 0 30px rgba(2, 33, 79, 0.65);
    -webkit-box-shadow: inset 0 0 30px rgba(2, 33, 79, 0.65);
    box-shadow:         inset 0 0 30px rgba(2, 33, 79, 0.65);

    .cls-1 {
      fill: #c80000;
      fill-rule: evenodd;
      stroke-width: 0;
    }
  }

  &.active {
    background: ${quoteBlue};
    background-size: cover;
    -moz-box-shadow: inset 0 0 30px rgba(2, 33, 79, 0.65);
    -webkit-box-shadow: inset 0 0 30px rgba(2, 33, 79, 0.65);
    box-shadow: inset 0 0 30px rgba(2, 33, 79, 0.65);

    .cls-1 {
      fill: #fff;
      fill-opacity: 0;
      stroke: #fff;
      stroke-linejoin: round;
      stroke-width: 3px;
      fill-rule: evenodd;
    }



    p,
    h3 {
      color: ${white};
    }

    .abbreviation {
      color: ${quoteBlue};
      text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    }
  }
  
  .team-name {
    font-weight: normal;
  }
  
  .wrapper {
    width: 100%;
  }
`;

export const Tab = styled.div`${TabStyle}`;

export const Logo = styled.div`
  width: 50%;
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
  margin: auto;
  
  ${({ logo }) => ` background-image: url('${logo}')`};
      
  &::after {
    content: '';
    display: block;
    padding-bottom: 80%;
  }
`;

export const TicketLink = styled.a`${TabStyle}`;



// WEBPACK FOOTER //
// ./src/components/city-selector/styles/city-tab.style.js